/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable react/react-in-jsx-scope */
import React, { useState, useContext, useEffect, useMemo } from "react";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import ForceLogoutApi from "../../../services/api/ForceLogout";
import Loader from "../../../components/common/Loader/Loader";
import Pagination from "../../../components/common/new/Pagination/Pagination";

function ForceLogout() {
  const [searchTerm, setSearchTerm] = useState("");
  const [sourceFilter, setSourceFilter] = useState("BDS_PORTAL");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loginHistory, setLoginHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(0);
  const PAGE_SIZE = 10;

  const toast = useContext(ToastAlertContext);

  // ---------------------------
  // Fetch login history from API
  // ---------------------------
  const fetchLoginHistory = async () => {
    try {
      setIsLoading(true);

      const resp = await ForceLogoutApi.getLoginHistory({
        pageNumber: 0,
        size: 1000,
      });

      const data = resp?.data ?? resp;
      const list =
        data?.content ??
        data?.data ??
        data?.items ??
        (Array.isArray(data) ? data : []);

      setLoginHistory(list);
      setIsLoading(false);
    } catch (error) {
      toast.show("Failed to fetch login history", AlertStatus.ERROR);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLoginHistory();
  }, []);

  // Normalize for search
  const norm = (v) => (v || "").toString().trim().toUpperCase();

  // ---------------------------
  // FILTER + SEARCH
  // ---------------------------
  const filtered = useMemo(() => {
    const base = loginHistory.filter((u) => u?.loginActiveStatus === false);

    return base.filter((user) => {
      const searchText = norm(Object.values(user).join(" "));
      const matchesSearch = searchText.includes(norm(searchTerm));
      const matchesSource = norm(user?.loginSource) === norm(sourceFilter);

      return matchesSearch && matchesSource;
    });
  }, [loginHistory, searchTerm, sourceFilter]);

  // ---------------------------
  // PAGINATION
  // ---------------------------
  const paged = useMemo(() => {
    const start = page * PAGE_SIZE;
    return filtered.slice(start, start + PAGE_SIZE);
  }, [filtered, page]);

  // Reset page + selection when filter/search changes
  useEffect(() => {
    setSelectedUsers([]);
    setPage(0);
  }, [searchTerm, sourceFilter]);

  // ---------------------------
  // SELECTION HANDLERS
  // ---------------------------
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(paged.map((u) => u.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const handleSelectUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  // ---------------------------
  // BULK LOGOUT HANDLER
  // ---------------------------
  const handleLogoutSelected = async () => {
    try {
      if (selectedUsers.length === 0) return;

      setIsLoading(true);

      await ForceLogoutApi.activateBulk(selectedUsers);

      toast.show(
        `${selectedUsers.length} user(s) logged out successfully!`,
        AlertStatus.SUCCESS
      );

      setLoginHistory((prev) =>
        prev.filter((u) => !selectedUsers.includes(u.id))
      );

      setSelectedUsers([]);
      setIsLoading(false);
    } catch (error) {
      toast.show("Failed to logout selected users", AlertStatus.ERROR);
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loader />;

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);

  return (
    <div style={{ padding: "8px", maxWidth: "100%", overflowX: "auto" }}>
      {/* --------------------- */}
      {/*  SEARCH + FILTER BAR  */}
      {/* --------------------- */}
      <div
        style={{
          display: "flex",
          gap: "8px",
          marginBottom: "8px",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: "0 1 300px",
            padding: "6px 10px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
          }}
        />

        <button
          onClick={handleLogoutSelected}
          disabled={selectedUsers.length === 0}
          style={{
            padding: "8px 20px",
            backgroundColor: selectedUsers.length > 0 ? "#dc3545" : "#ccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: selectedUsers.length > 0 ? "pointer" : "not-allowed",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          Logout Selected ({selectedUsers.length})
        </button>

        <select
          value={sourceFilter}
          onChange={(e) => setSourceFilter(e.target.value)}
          style={{
            padding: "6px 10px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            fontSize: "14px",
            minWidth: "180px",
          }}
        >
          <option value="BDS_PORTAL">BDS_PORTAL</option>
          <option value="CONTRI_ADMIN">CONTRI_ADMIN</option>
          <option value="CONTRI">CONTRI</option>
          <option value="ANDROID">ANDROID</option>
          <option value="IOS">IOS</option>
        </select>
      </div>

      <div style={{ marginBottom: "8px", fontSize: "12px", color: "#666" }}>
        Filtered: {filtered.length} | Page: {page + 1} /{" "}
        {Math.max(totalPages, 1)} | Selected: {selectedUsers.length}
      </div>

      {/* --------------------- */}
      {/*       TABLE           */}
      {/* --------------------- */}
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "13px",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f5f5f5",
                borderBottom: "2px solid #ddd",
              }}
            >
              <th style={{ padding: "8px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    paged.length > 0 && selectedUsers.length === paged.length
                  }
                />
              </th>
              <th style={{ padding: "8px" }}>Member ID</th>
              <th style={{ padding: "8px" }}>Address</th>
              <th style={{ padding: "8px" }}>IP</th>
              <th style={{ padding: "8px" }}>City</th>
              <th style={{ padding: "8px" }}>Login Time</th>
              <th style={{ padding: "8px" }}>Login Source</th>
              <th style={{ padding: "8px" }}>Status</th>
            </tr>
          </thead>

          <tbody>
            {paged.length > 0 ? (
              paged.map((user) => (
                <tr key={user.id} style={{ borderBottom: "1px solid #eee" }}>
                  <td style={{ padding: "8px", textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(user.id)}
                      onChange={() => handleSelectUser(user.id)}
                    />
                  </td>
                  <td style={{ padding: "8px" }}>{user.memberId || "-"}</td>
                  <td style={{ padding: "8px" }}>{user.address || "-"}</td>
                  <td style={{ padding: "8px" }}>{user.clientIp || "-"}</td>
                  <td style={{ padding: "8px" }}>{user.city || "-"}</td>
                  <td style={{ padding: "8px" }}>
                    {user.createdAt
                      ? new Date(user.createdAt).toLocaleString("en-IN", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })
                      : "-"}
                  </td>
                  <td style={{ padding: "8px" }}>{user.loginSource || "-"}</td>
                  <td style={{ padding: "8px" }}>
                    <span
                      style={{
                        color:
                          user.loginActiveStatus === false
                            ? "#28a745"
                            : "#dc3545",
                        fontWeight: "500",
                      }}
                    >
                      {user.loginActiveStatus === false ? "Active" : "Inactive"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="8"
                  style={{
                    padding: "16px",
                    textAlign: "center",
                    color: "#999",
                  }}
                >
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* --------------------- */}
      {/*     PAGINATION        */}
      {/* --------------------- */}
      {totalPages > 1 && (
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onChange={(p) => setPage(p)}
          onPageSizeClick={(size) => {
            console.log("New size:", size);
          }}
        />
      )}
    </div>
  );
}

export default ForceLogout;
